<script>
import ApiService from "../../Utils/axios";
import Table from "./EditableTable";
import Loader from "../../components/xray/Loader";

export default {
  components: { Table, Loader },
  data() {
    return {
      list: [],
      done: false,
      columns: [
        { editable: true, deleteable: true },
        {
          label: "Nom",
          key: "name",
          class: "text-left w-25",
        },
        { label: "E-mail", key: "email", class: "text-left" },
        { label: "Droits", key: "roles", class: "text-left" },
        { label: "Institution", key: "institution.name", class: "text-center" },
        { label: "Services", key: "service", class: "text-center" },
        {
          label: "Action",
          key: "action",
          class: "text-center",
        },
      ],
    };
  },
  beforeMount() {
    this.fetchList();
  },
  mounted() {
    document.title = `${this.$t("pageTitles.users")} - Auditor'`;
  },
  methods: {
    fetchList() {
      this.done = false;
      new ApiService()
        .get("/api/user")
        .then((res) => {
          this.list = res.data.data;
          console.log(this.list);
          this.done = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<template>
  <div>
    <Table
      v-if="done && list.length"
      :addBtn="{ text: $t('buttons.add'), link: '/user/create' }"
      :tableTitle="$t('pageTitles.users')"
      :rows="list"
      :cols="columns"
      :fetchList="fetchList"
    />
    <b-container
      v-if="done && !list.length"
      style="height: 75vh"
      class="text-center"
      fluid
      ><h5>Aucun utilisateur trouvé dans notre base de données.</h5>
      <b-button
        class="mt-3"
        variant="primary"
        :to="'/' + $i18n.locale + '/user/create'"
        ><i class="fas fa-plus"></i> {{ $t("buttons.add") }}
      </b-button>
    </b-container>
    <Loader v-if="!done" />
  </div>
</template>
